import { Liquid as AntLiquid } from "@ant-design/charts";
import { FC } from "react";

interface Props {
  conversionRate: number;
}

const Liquid: FC<Props> = ({ conversionRate }) => (
  <AntLiquid
    percent={conversionRate}
    // use a variable key to force chart reRender
    key={conversionRate}
    // `renderer="svg"` will cause render problems in firefox
    renderer="canvas"
    style={{ height: "40vh", width: "40vh" }}
    statistic={{
      content: {
        formatter: (chartData) => {
          if (typeof chartData?.percent === "number") {
            return `${(chartData.percent * 100).toFixed(0)}%`;
          }
          return "0%";
        },
      },
    }}
  />
);

export default Liquid;
